import { USER_PROPERTIES_UPDATE } from '#utils/tagging/events';
import { set } from '#utils/tagging/tag';
import { LoginEventProps } from '#utils/tagging/eventParams';

export const tagUserLogin = (params: LoginEventProps) => {
  set(USER_PROPERTIES_UPDATE, params);
};
